<button
  type="button"
  class="hidden lg:flex justify-center items-center rounded-radius-circle bg-header-actionitem-bg h-[40px] w-[40px]"
  [attr.aria-label]="'quick-navigation.title' | translate"
  (click)="onQuickNavigationClick()"
>
  <svg-icon key="search-20" size="24"></svg-icon>
</button>

<div class="hidden lg:flex items-center gap-2">
  <button
    type="button"
    class="flex justify-center items-center rounded-radius-circle bg-header-actionitem-bg h-[40px] w-[40px]"
    [appPopover]="menuTpl"
    trigger="manual"
    position="bottom-left"
    [showArrow]="false"
    [isPopoverOpen]="isDesktopMenuOpen()"
    (click)="toggleDesktopMenu()"
    (popoverClose)="closeDesktopMenu()"
  >
    <svg-icon key="profile-40" size="40"></svg-icon>
  </button>

  <div class="flex flex-col">
    <span class="text-sm font-medium">{{ vm().name }}</span>
    @if (vm().originalName; as originalName) {
      <span class="text-xs">{{ 'header-profile-section.impersonated-by' | translate: { originalName } }}</span>
    }
  </div>
</div>

<button
  type="button"
  class="hidden lg:flex justify-center items-center rounded-radius-circle bg-header-actionitem-bg h-[40px] w-[40px]"
  (click)="onLogoutClick()"
>
  <svg-icon key="logout-40" size="24"></svg-icon>
</button>

<button
  type="button"
  class="flex lg:hidden justify-center items-center text-header-actionitem-bg h-[40px] w-[40px]"
  [attr.aria-expanded]="isMobileMenuOpen()"
  [attr.aria-label]="'header-profile-section.menu' | translate"
  (click)="toggleMobileMenu()"
>
  <svg-icon key="dot-dot-dot-32" size="32"></svg-icon>
</button>

<ng-template #menuTpl>
  <app-dropdown-menu-dropdown>
    <app-dropdown-menu-option (click)="onPreferencesClick()">
      {{ 'preferences.title' | translate }}
    </app-dropdown-menu-option>
    @if (vm().originalName) {
      <app-dropdown-menu-option (click)="onExitImpersonationClick()">
        {{ 'header-profile-section.exit-impersonation' | translate }}
      </app-dropdown-menu-option>
    }
  </app-dropdown-menu-dropdown>
</ng-template>

<ng-template #mobileMenuTpl>
  <div
    class="flex flex-col w-[calc(100vw-32px)] h-[min(396px,calc(100vh-48px))] overflow-y-auto rounded-radius-container bg-background-fixed drop-shadow-dropdown py-4 text-lg font-medium"
  >
    <button
      type="button"
      class="flex shrink-0 items-center gap-2 border-y border-stroke-tertiary px-5 py-2 text-left"
      (click)="onPreferencesClick()"
    >
      <svg-icon key="profile-v-2-40" size="40"></svg-icon>
      <span>{{ 'preferences.title' | translate }}</span>
    </button>
    @if (vm().originalName) {
      <button
        type="button"
        class="flex shrink-0 items-center gap-2 border-b border-stroke-tertiary px-5 py-2 text-left"
        (click)="onExitImpersonationClick()"
      >
        <svg-icon key="exit-v-2-40" size="40"></svg-icon>
        <span>{{ 'header-profile-section.exit-impersonation' | translate }}</span>
      </button>
    }
    <button
      type="button"
      class="flex shrink-0 items-center gap-2 border-b border-stroke-tertiary px-5 py-2 text-left"
      (click)="onLogoutClick()"
    >
      <svg-icon key="exit-v-2-40" size="40"></svg-icon>
      <span>{{ 'header-profile-section.logout' | translate }}</span>
    </button>
  </div>
</ng-template>
